export default __webpack_public_path__ + "static/media/progress-active.90ccf69d.svg";